module.exports = __webpack_public_path__ + "static/media/add-logo-desktop-en.98997254.webp";